import { Button as DefaultButton } from '@kega/sps-elements';

import { ShoppingbagIcon } from '../icons';
import { t } from '../../lib/translations';

import classes from './Button.module.css';
import classNames from 'classnames';

const AddToCartSmall = ({ showText = false, ...props }) => {

    const className = classNames(classes.root, classes.atc, classes.icon);

    return (
        <DefaultButton className={className} {...props} >
            <ShoppingbagIcon size={20} title="toevoegen-product" />
            {showText && <span className={classes.button_text}>{t('productlist.add_to_cart')}</span>}
        </DefaultButton>
    );
}

export default AddToCartSmall;